"use client";

import Link from "next/link";
import { useEffect, useRef } from "react";
import { LayoutDashboard, LogOut, User } from "@app-foundation/icons/lucide";
import { AvatarPhoto } from "@/features/web-avatars/components/AvatarPhoto";
import { workbenchNavigation } from "@/features/workbench/navigation";
import type { WorkbenchIdentity } from "@/features/workbench/identity";
import type { AgentType } from "@/features/onboarding/agent-type";
import { LogoutButton } from "./LogoutButton";

export function HeaderAccountMenu({ home, avatar, identity, agentType, avatarEnabled = false, authorizationEnabled = false, showProjects = false, navigationPrefetch }: { home: string; avatar?: string | null; identity?: WorkbenchIdentity; agentType?: AgentType | null; avatarEnabled?: boolean; authorizationEnabled?: boolean; showProjects?: boolean; navigationPrefetch?: false }) {
  const nav = identity ? workbenchNavigation({ identity, agentType, home, avatarEnabled, authorizationEnabled, showProjects }).filter(item => item.href !== home) : [];
  const details = useRef<HTMLDetailsElement>(null);
  useEffect(() => {
    const closeOutside = (event: PointerEvent) => {
      if (event.target instanceof Node && !details.current?.contains(event.target)) details.current?.removeAttribute("open");
    };
    document.addEventListener("pointerdown", closeOutside);
    return () => document.removeEventListener("pointerdown", closeOutside);
  }, []);
  return <details ref={details} className="wb-account-menu" onKeyDown={event => {
    if (event.key === "Escape") {
      details.current?.removeAttribute("open");
      details.current?.querySelector("summary")?.focus();
    }
  }} onBlur={event => {
    if (!event.currentTarget.contains(event.relatedTarget)) details.current?.removeAttribute("open");
  }}>
    <summary className="wb-account-home" aria-label="账号菜单">
      <span className="wb-avatar">{avatar ? <AvatarPhoto src={avatar} label="账号头像" className="h-full w-full !rounded-full" /> : <User size={16} strokeWidth={1.8} aria-hidden="true" />}</span>
    </summary>
    <div className="wb-account-menu-panel">
      <Link prefetch={navigationPrefetch} href={home} className="wb-account-menu-item" onClick={() => details.current?.removeAttribute("open")}><LayoutDashboard size={16} aria-hidden="true" />控制台</Link>
      {nav.map(({ href, label, icon: Icon }) => <Link key={href} prefetch={navigationPrefetch} href={href} className="wb-account-menu-item" onClick={() => details.current?.removeAttribute("open")}><Icon size={16} aria-hidden="true" />{label}</Link>)}
      <LogoutButton className="wb-account-menu-item"><LogOut size={16} aria-hidden="true" /><span className="text-[var(--color-alert)]">退出登录</span></LogoutButton>
    </div>
  </details>;
}
